<script lang="ts">
    import "carbon-components-svelte/css/all.css";
    import {Button, Theme, Content, Header, SideNav, SideNavDivider, SideNavItems, SideNavMenu, SideNavMenuItem, SkipToContent, HeaderUtilities} from "carbon-components-svelte";
    import type { CarbonTheme } from "carbon-components-svelte/types/Theme/Theme.svelte";

    import { Constants } from "./utils/constants";
    import { onMount } from "svelte";
    import { Repository } from "./libraries/repository";
    import { login } from "./stores";
    import UserAvatarFilledAlt from "carbon-icons-svelte/lib/UserAvatarFilledAlt.svelte";
    import Login from "./components/Login.svelte";
    import { Router, Route, navigate } from "svelte-navigator";
    import Home from "./components/Home.svelte";
    import Templates from "./components/Templates.svelte";
    import Indemnities from "./components/Indemnities.svelte";
    import TemplateForm from "./components/TemplateForm.svelte";
    import TemplateEditForm from "./components/TemplateEditForm.svelte";
    import type { User } from "./model/user";
    import DashboardVersion from "./components/DashboardVersion.svelte";
    import IndemnityForm from "./components/IndemnityForm.svelte";
    import IndemnityEditForm from "./components/IndemnityEditForm.svelte";
    import { Logout } from "carbon-icons-svelte";
    import { LocalStorage } from "./libraries/localStorage";

    export let theme: CarbonTheme;
    let isSideNavOpen: boolean = false; 
    let repository: Repository = new Repository();
    let user: User;
    $: isLogin = false;

    $: if(isLogin){
        user = LocalStorage.getUserStorage();
    }

    onMount(() => {
        user = LocalStorage.getUserStorage();
        login.isLogin.subscribe((value) => {
            isLogin = value;
        })
    })
</script>

<Theme bind:theme 
	tokens={{
		"interactive-01": Constants.primaryOrange,
		"hover-primary": Constants.lightOrange,
		"active-primary": Constants.mediumOrange,
		"interactive-03": Constants.mediumOrange,
		"interactive-04": Constants.mediumOrange,
		"brand-01": Constants.mediumOrange,
		"brand-03": Constants.mediumOrange,
		"background-brand": Constants.mediumOrange,
		"interactive": Constants.mediumOrange,
		"border-interactive": Constants.mediumOrange,
		"active-tertiary": Constants.mediumOrange,
		"hover-tertiary": Constants.mediumOrange,
		"hover-primary-text": Constants.lightOrange,
		"focus": Constants.mediumOrange,
		"button-secondary-active": Constants.primaryOrange,
		"buttontertiaryactive": Constants.primaryOrange,
        "link-01": Constants.primaryOrange,
        "link-02": Constants.mediumOrange,
        "inverse-link": Constants.lightOrange
  }}/>
<Header company="Guglielmo" platformName="Manleve" bind:isSideNavOpen on:click={() => navigate("/")}>
    <svelte:fragment slot="skip-to-content">
        <SkipToContent />
    </svelte:fragment>
    <HeaderUtilities> 
        {#if isLogin}
        {#if user}
            <div class="header-user-info">
                <UserAvatarFilledAlt color="#fff" size={20} />
                <p class="text-lowercase">{user.username} - {user.role}</p>
            </div>           
        {/if}
        <Button class="logout-button" icon={Logout} iconDescription="Logout" on:click={repository.logOut} />
        {/if}
    </HeaderUtilities>
</Header>

<Router>
    {#if isLogin}
    <SideNav bind:isOpen={isSideNavOpen}>
        <SideNavItems>
            <SideNavMenu text="Template">
                <SideNavMenuItem text="Lista" on:click={() => navigate("/templates/")} />
                {#if user.role === "SPECIALADMIN"}
                <SideNavMenuItem text="Crea nuovo" on:click={() => navigate("/templates/new")} />
                {/if}
            </SideNavMenu>
            <SideNavDivider />
            <SideNavMenu text="Manleve">
                <SideNavMenuItem text="Lista" on:click={() => navigate("/indemnities")} />
                <SideNavMenuItem text="Crea nuova" on:click={() => navigate("/indemnities/new")} />
            </SideNavMenu>   
        </SideNavItems>
        <DashboardVersion />
    </SideNav>
    {/if}
    <Content>
        {#if isLogin}
        <Route path="/">
            <Home></Home>
        </Route>
        <Route path="/templates/*">
            <Route path="/">
                <Templates repository={repository} user={user}></Templates>
            </Route>
            <Route path="/new">
                <TemplateForm repository={repository}></TemplateForm>
            </Route>
            <Route path="/update/:id" let:params>
                <TemplateEditForm repository={repository} templateUuid={params.id}></TemplateEditForm>
            </Route>
        </Route>
        <Route path="/indemnities/*">
            <Route path="/">
                <Indemnities repository={repository}></Indemnities>
            </Route>
            <Route path="/new">
                <IndemnityForm repository={repository}></IndemnityForm>
            </Route>
            <Route path="/update/:id" let:params>
                <IndemnityEditForm repository={repository} indemnityUuid={params.id}></IndemnityEditForm>
            </Route>
        </Route>
        {:else}
        <Login repository={repository}></Login>
        {/if}
    </Content>
</Router>

